import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";

import { fetchFtmSkills } from "../service";
import CardTemplate from "./template/CardTemplate";
import DivSpinner from "../../../components/divSpinner";
import { theme } from "../../../theme";
import DocumentTypes from "./documentTypes/DocumentTypes";
import MarkAsApproved from "./MarkAsApproved";

const LoadingComponent = () => (
    <div style={{ height: `${window.innerHeight - 387}px` }}>
        <DivSpinner />
    </div>
);

const FtmSkills = ({isHistory = false}) => {
    const { ftm_id } = useParams();

    const [loading, setLoading] = useState(true);
    const [ftmSkills, setFtmSkills] = useState([]);
    const [showDocumentTypes, setShowDocumentTypes] = useState(false);
    const [selectedFtmSkill, setSelectedFtmSkill] = useState(null);
    const [refreshCounter, setRefreshCounter] = useState(0);

    const handleRefresh = useCallback(() => {
        setRefreshCounter(prev => prev + 1);
    }, []);

    useEffect(() => {
        const getFtmSkills = async () => {
            try {
                setLoading(true);
                const response = await fetchFtmSkills(ftm_id);

                setFtmSkills(response?.status === "Success" ? response.skills || [] : []);
            } catch (error) {
                console.error("Error fetching FTM skills:", error);
                setFtmSkills([]);
            } finally {
                setLoading(false);
            }
        };

        if (ftm_id) getFtmSkills();
    }, [ftm_id, refreshCounter]);

    const handleOpenSkillsDocuments = useCallback((ftmSkill) => {
        setSelectedFtmSkill(ftmSkill);
        setShowDocumentTypes(true);
    }, []);

    const handleCloseDocumentTypes = useCallback(() => {
        setShowDocumentTypes(false);
        setSelectedFtmSkill(null);
    }, []);

    return (
        <CardTemplate 
            title="Certificates Documents" 
            isHistory={isHistory}
        >
            {loading ? (
                <LoadingComponent />
            ) : (
                <ul className="list-group" style={{height: "450px", overflow: "auto"}}>
                    {ftmSkills.map((ftmSkill) => {
                        const { sub_skill, ftm_skill_is_approve, id } = ftmSkill;
                        const skillName = sub_skill?.skill?.skill_name;
                        const skillIcon = sub_skill?.skill?.skill_web_app_icon;
                        const subSkillName = sub_skill?.sub_skill_name;

                        return (
                            <li
                                key={id || subSkillName} // prefer unique id over index
                                className="list-group-item list-group-item-action border-0 d-flex justify-content-between border-radius-0-2 cursor-pointer"
                                onClick={() => handleOpenSkillsDocuments(ftmSkill)}
                            >
                                <div className="d-flex flex-column">
                                    <h6 className={`mb-1 text-dark font-weight-bold text-${isHistory ? 'sm' : 'lg'}`}>
                                        {skillIcon && (
                                            <i className={`material-icons opacity-10 text-${theme.main} me-2`}>
                                                {skillIcon}
                                            </i>
                                        )}
                                        {subSkillName}
                                    </h6>
                                    {skillName && <span className="text-xs">#{skillName}</span>}
                                </div>
                                <div className="d-flex align-items-center text-sm">
                                    <i className={`material-icons opacity-10 ms-2 ${ftm_skill_is_approve === 1 ? `text-${theme.main}` : ""}`}>
                                        {ftm_skill_is_approve === 1 ? "verified" : "add_circle"}
                                    </i>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}

            {!isHistory && <MarkAsApproved approvalProcessKey="ALL_SKILLS_CERTIFICATES_APPROVED" />}

            {/* Modal/Popup for document types */}
            <DocumentTypes
                show={showDocumentTypes}
                handleClose={handleCloseDocumentTypes}
                skill={selectedFtmSkill}
                handleParentRefresh={handleRefresh}
            />
        </CardTemplate>
    );
};

export default FtmSkills;